import { useCallback, useState } from 'react';

import { InboxEntry, UpdateInboxEntryInput } from '@this+that/models';
import log from 'loglevel';

import { useUpdateInboxEntry as useUpdateInboxEntryService } from '../../services/inboxEntries.service';

export const useUpdateInboxEntry = () => {
  const {
    updateInboxEntry: updateInboxEntryService,
    loading,
    error,
  } = useUpdateInboxEntryService();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateInboxEntry = useCallback(
    async (
      inboxEntry: UpdateInboxEntryInput,
    ): Promise<InboxEntry | null | undefined> => {
      setIsUpdating(true);
      try {
        const updatedEntry = await updateInboxEntryService(inboxEntry);
        return updatedEntry;
      } catch (error) {
        log.error('Error updating inbox entry:', error);
        throw error;
      } finally {
        setIsUpdating(false);
      }
    },
    [updateInboxEntryService],
  );

  const updateInboxEntryField = useCallback(
    async (
      inboxEntryId: string,
      field: keyof Pick<InboxEntry, 'subject' | 'description'>,
      value: string,
    ): Promise<InboxEntry | null | undefined> => {
      const updateData: UpdateInboxEntryInput = {
        id: inboxEntryId,
        [field]: value,
      };

      return handleUpdateInboxEntry(updateData);
    },
    [handleUpdateInboxEntry],
  );

  return {
    handleUpdateInboxEntry,
    updateInboxEntryField,
    loading: loading || isUpdating,
    error,
  };
};
